export function Tooltip({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <span className="relative group/tooltip">
      {children}
      <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 px-1.5 py-0.5 rounded text-[10px] leading-tight bg-gray-900 text-white whitespace-nowrap opacity-0 group-hover/tooltip:opacity-100 transition-opacity duration-150 dark:bg-gray-700">
        {label}
      </span>
    </span>
  );
}
